import React, { Suspense } from 'react'
import FlexView from 'react-flexview/lib'
import { ReactComponent as DroneImageSvg } from '../../assets/claims/incident-details.svg'
import { ReactComponent as BriefcaseImageSvg } from '../../assets/claims/damaged-equipment.svg'
import { ReactComponent as DocImageSvg } from '../../assets/claims/incident-doc.svg'
import './ClaimEnter.scss'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import NewFillButton from '../Core/NewFillButton'
import { lazyWithPreload } from '../../utilities/RLazyLoading'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { SessionService } from '../../services/SessionService'
import { isMobile } from 'react-device-detect'
import { useMediaQuery, Checkbox, FormControlLabel } from '@material-ui/core'
const FlowLogin = lazyWithPreload(() =>
  import('../Login/FlowLogin').then((module) => ({
    default: module.FlowLogin,
  }))
)
const classNames = require('classnames')

export const ClaimEnter = () => {
  const isMobileByWidth = !useMediaQuery((theme) => theme.breakpoints.up('md'))

  const startClaim = () => {
    if (SessionService.isLoggedIn())
      EventEmitterService.dispatch(EventKey.CLAIM_NOTICE_INFO)
    else EventEmitterService.dispatch(EventKey.FLOW_NEED_LOGIN)
  }

  return (
    <>
      <br />
      <div className="text-title blue bold margin-top-basic">
        Filling a claim with SkyWatch.AI is quick and easy!
      </div>
      <div className="text-body margin-top-basic">
        By clicking ‘File a claim’ below you will by asked to
      </div>
      <br />
      <FlexView column={isMobileByWidth} className="margin-top-basic">
        <FlexView
          column={!isMobileByWidth}
          hAlignContent={isMobileByWidth ? 'left' : 'center'}
          vAlignContent={'center'}>
          <DroneImageSvg className="claim-img" />
          <div className="text-body blue textcenter margin-top-basic claim-img-desc">
            Provide incident details
          </div>
        </FlexView>

        <FlexView
          column={!isMobileByWidth}
          hAlignContent={isMobileByWidth ? 'left' : 'center'}
          vAlignContent={'center'}
          className="margin-left-basic">
          <BriefcaseImageSvg className="claim-img" />
          <div className="text-body blue textcenter margin-top-basic claim-img-desc">
            Select damaged equipment
          </div>
        </FlexView>

        <FlexView
          column={!isMobileByWidth}
          hAlignContent={isMobileByWidth ? 'left' : 'center'}
          vAlignContent={'center'}
          className="margin-left-basic">
          <DocImageSvg className="claim-img" />
          <div className="text-body blue textcenter margin-top-basic claim-img-desc">
            Upload incident documentation
          </div>
        </FlexView>
      </FlexView>
      <br />
      <FlexView
        column={isMobileByWidth}
        hAlignContent={!isMobileByWidth ? 'left' : 'center'}
        className="margin-top-basic"
        vAlignContent={'center'}>
        <MailOutlineIcon className="black margin-right-6" fontSize={'large'} />
        <div className="text-small black claim-rep-text">
          A SkyWatch.AI representative will contact you as soon as possible
        </div>
      </FlexView>
      <br />

      <FlexView
        className="margin-top-basic"
        hAlignContent={!isMobileByWidth ? 'left' : 'center'}>
        <NewFillButton onClick={startClaim}>File a claim</NewFillButton>
      </FlexView>

      <Suspense fallback={<div />}>
        <FlowLogin finishedEvent={EventKey.CLAIM_NOTICE_INFO} />
      </Suspense>
    </>
  )
}
